import 'react-hot-loader/patch'
import React from 'react'
import ReactDOM from 'react-dom'

import { AppContainer } from 'react-hot-loader'
import RootContainer from './root'

const render = (Component: React.ComponentType): void => {
  ReactDOM.render(
    <AppContainer>
      <Component />
    </AppContainer>,
    document.getElementById('app')
  )
}

render(RootContainer)

if (module.hot) {
  module.hot.accept('./root', () => {
    const NextRootContainer: React.ComponentType = require('./root').default
    render(NextRootContainer)
  })
}
